import React, { useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
// import "../purchasedAssorts.scss";
import { HiOutlineClock, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import format from "date-fns/format";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import SingleExercise from "./singleExerciseDesktop";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import SelectPassBar from "./selectPassBar";
import SelectPassModalFooter from "./selectPassModalFooter";
import { useTranslation } from "react-i18next";
import HtmlTooltip from "@mui/material/Tooltip";
import EAButton from "../../shared/Buttons/EAButton";
import { IoArrowForward } from "react-icons/io5";
import EAModal from "../../shared/Modal/EAModal";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { FINALIZE_PAGE } from "../../../routes";
import { useNavigate } from "react-router-dom";

interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}
const SelectPassDesktop: React.FC<IProps> = ({ ticket, getSelect }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const { prolongPass } = useBasketManager();
  const navigate = useNavigate();
  const finalizeFunction = () => {
      setTimeout(() => {
        navigate(FINALIZE_PAGE);
      }, 600);
    
  };

  const newValidTo = new Date(ticket.validto);
  newValidTo.setDate(newValidTo.getDate() + 1);

  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );

  return (
    <React.Fragment>
      {(ticket.passtype === 2 || ticket.passtype === 3) && ticket.ticket === false && (
        <div className="purchased-assort">
          <div className="purchased-assort_left">
            <div className="purchased-assort_startIcon">
              <HiOutlineTicket className="myAccount-ticketLine_icon" />
            </div>

            <div className="purchased-assort_body">
              <h5>
                {ticket.name}
                {ticket.description.length > 10 && (
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <article
                          className="tooltip-description"
                          dangerouslySetInnerHTML={{ __html: ticket.description }}
                        ></article>
                      </React.Fragment>
                    }
                  >
                    <b>
                      <BiInfoCircle className="tooltip-icon" />
                    </b>
                  </HtmlTooltip>
                )}
              </h5>

              <span className="purchased-assort_body__details">
                <HiOutlineClock /> {t("wazny_od")}:{" "}
                <b>
                  {format(ticket.validfrom, "dd.MM.yyyy")}r. | {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
                </b>
              </span>

              <div className="purchased-assort__entrances">
                {ticket.entrances - ticket.exercises.length > 200 ? (
                  <div className="purchased-assort__entrances">
                    <b>
                      <IoArrowForward /> {t("ilosc_wejsc")}: bez limitu wejsć
                    </b>
                  </div>
                ) : (
                  <div className="purchased-assort__entrances">
                    <b>
                      <IoArrowForward /> {t("pozostalo")}:{ticket.entrances - ticket.exercises.length} {t("wejsc")}
                    </b>
                  </div>
                )}
              </div>
            </div>
          </div>

          {ticket.extendAllowed && (
            <EAButton
              title={t("przedluz_karnet")}
              onClick={() => {
                prolongPass(ticket.assortIds, 1, newValidTo);
                finalizeFunction();
              }}
              variant="filled"
            />
          )}

          <div className="purchased-assort_action">
            <EAButton title={t("pokaz_terminy")} onClick={() => setAssignedList(!open)} fullWidth variant="outlined" />

            <EAButton title={t("pokaz_kod_qr")} onClick={() => setOpen(!open)} fullWidth endIcon={<HiQrcode />} />
          </div>
        </div>
      )}

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
          leftType="exercise"
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <EAButton title={t("gotowe_schowaj")} onClick={() => setOpen(!open)} fullWidth />
        </ModalComponent>
      )}

      {assignedList && (
        // <ModalComponent
        //   footer={false}
        //   open={assignedList}
        //   closeModal={() => setAssignedList(false)}
        //   title={t("najblizsze_rezerwacje")}
        //   onAccept={() => setAssignedList(false)}
        // >
        //   <React.Fragment>
        //     <SelectPassBar ticket={ticket} />

        //     {ticket.exercises[0] && (
        //       <div>
        //         {ticket.exercises.map((exercise, index) => (
        //           <div key={index}>
        //             <SingleExercise exercise={exercise} getSelect={getSelect} />
        //           </div>
        //         ))}
        //       </div>
        //     )}
        //     {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
        //   </React.Fragment>
        // </ModalComponent>

        <EAModal
          isOpen={assignedList}
          onClose={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          hideButtons
          acceptButtonLabel={t("przeczytalem")}
          onAccept={() => setAssignedList(false)}
        >
          <div className="upcoming-events">
            <SelectPassBar ticket={ticket} />

            {ticket.exercises[0] && (
              <div>
                {ticket.exercises.map((exercise, index) => (
                  <div key={index}>
                    <SingleExercise exercise={exercise} getSelect={getSelect} />
                  </div>
                ))}
              </div>
            )}
            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </div>
        </EAModal>
      )}
    </React.Fragment>
  );
};

export default SelectPassDesktop;
